var Curriculog = Curriculog || {};

/**
 * A dialog that allows for arbitrary text entered by the user to be returned
 * and used within the callback if necessary.
 *
 * Basic usage:
 *
 * new Curriculog.LeaveCommentDialog({
 *     callback: function (data) {
 *         console.log(data);
 *     }
 * });
 *
 */

Curriculog.LeaveCommentDialog = (function ($, _, Backbone, LeaveCommentDialog) {
    LeaveCommentDialog = Curriculog.WarningDialog.extend({
        title: 'Leave a Comment',
        message: '<br/><br/>Would you like to leave a comment with your decision?',
        buttons: {'Submit decision with comment': 'displayCommentForm', 'Submit decision without comment': '_processData'},

        displayCommentForm: function () {
            // Build the comment form and submit button to replace the current content and
            // buttons of the dialog
            var $commentForm = $('<div/>')
                    .append('<p style="margin: 10px 0 0;">Please fill out your comment below</p>')
                    .append('<p class="error-text"></p>')
                    .append($('<div/>', {
                        html: '<textarea style="width: 100%; min-height: 200px; margin: 20px 0 0;"></textarea>'
                    })),
                $submitButton = $('<button class="submit-button" type="button">Submit</button>').button(),
                $closeButton = $('<button class="close" type="button">Close</button>').button();

            // Replace the current content of the dialog
            this.$el.html($commentForm);

            // Replace the current buttons of the dialog
            this.$el
                .siblings('.ui-dialog-buttonpane')
                .html($submitButton[0].outerHTML + $closeButton[0].outerHTML);

            // Bind the button 'on click' events
            this.bindButtonEvents('.submit-button', '.close');

            // Reposition the dialog box to center of screen and reset the height
            // after adding in content
            this.option({
                position: { my: 'center', at: 'center', of: window },
                height: 'auto',
            });
        },

        bindButtonEvents: function (submit, close) {
            // Bind a click event to the submit button so that we can process the data
            // when the submit button is clicked
            $(submit).on('click', {
                    that: this,
                    input: this.$el.find('textarea'),
                },
                //Make sure to debounce the function so that fast clicking does not occur
                _.debounce(this._formSubmitted, 1000, true)
            );

            $(close).on('click', this.close);
        },

        _formSubmitted: function (event) {
            var data = {
                    comment: event.data.input.val()
                };

            // If the user didn't write a comment, show an error
            if (!data.comment.trim()) {
                event.data.that.$el
                    .find('.error-text')
                    .html('<span class="error">Please enter a comment and try again</span>')
                    .css({'margin': '10px 0 0'});

                return;
            }

            event.data.that._processData(data);
        },

        _processData: function (data) {
            if (this.callback) {
                this.callback(data);
            }

            this.close();
        },
    });

    return LeaveCommentDialog;

})($, _, Backbone, Curriculog.LeaveCommentDialog || {});